import request from '@/config/axios'

export const getPromoList = () => request.get({ url: '/rental/home/promo/list' })
export const getPromo = (id: number) => request.get({ url: '/rental/home/promo/get', params: { id } })
export const createPromo = (data: any) => request.post({ url: '/rental/home/promo/create', data })
export const updatePromo = (data: any) => request.put({ url: '/rental/home/promo/update', data })
export const deletePromo = (id: number) => request.delete({ url: '/rental/home/promo/delete', params: { id } })
